import { CLIENT_NODE_ID } from "../../../../services/url";
import { GestDoc } from "../../../../services/GestDoc";
import {
  isValidDocumentID,
  validateDocType,
  validateStandarisedFieldsSupplements,
} from "../../../../utils/validation";
import { isValidIban } from "../../../../utils/iban";
import {
  RiskDetailPersonDataDto,
  RiskDetailPetDataDto,
} from "../../../clients/clients-policies/dto/detail-clients-policies-layout-dto";
import { validateFields } from "../components/assets";
import { addressData } from "../new-insured/utils";
import { getPolicyNumber } from "../utils";
import { transformPayType } from "../components/variable-data/utils";
import { getFileExtension } from "../../../../utils/utility";

import { FormValues } from "../hooks/hooks.types";
import {
  AddressData,
  Check,
  ContactData,
  DefaultCheck,
  HasBasicDataValidationType,
  InitialDataType,
  PhoneData,
  ResultMergeInsurancesAndTaker,
  Taker,
} from "./basic-data.types";
import { FormatedSupplementDoc } from "../utils.type";
import { DocumentType, GestDocFileInfoResponseDto } from "../../../../models/gest-doc-models";
import { getUserCode } from "../../../../utils/mediatorCode";
import { PERSONA_TYPE } from "../../../../constants/supplements";

export const initialData = (supplementType: string): InitialDataType => {
  return {
    mediator: getPolicyData().mediator,
    policy: getPolicyNumber(),
    paymentType: transformPayType(getPolicyData().paymentType),
    newPaymentType: "",
    check: defaultCheck,

    nameSelected: "-1",
    name: "",
    firstName: "",
    newName: "",
    newLastname1: "",
    lastname1: "",
    newLastname2: "",
    lastname2: "",
    docType: "",
    newDocType: "",
    docNumber: "",
    newDocNumber: "",
    birthDate: "",
    newBirthDate: "",
    gender: "",
    newGender: "",
    newNationality: "",
    orden: "",
    
    petNewName: "",
    newPetBirthdate: "",
    petType: "",
    newPetType: "",
    breed: "",
    newBreed: "",
    newNumChip: "",
    
    address: { ...addressData, allInsurancesChange: false },
    oldProvince: "",
    oldTown: "",
    oldAddress: "",
    
    phone: {
      mobilePhone: "",
      landlinePhone: "",
    },
    newMobilePhone: "",
    newPhone: "",
    email: "",
    newEmail: "",

    isAdministrative: supplementType === "SUPLEMENTOS ADMINISTRATIVOS",
    isEconomical: supplementType === "SUPLEMENTOS ECONOMICOS",
    checkPersonId: false,

    documents: { uploadDocuments: [] },
  };
};

export const defaultCheck: DefaultCheck = {
  name: false,
  doc: false,
  birthDate: false,
  gender: false,
  nationality: false,
  petName: false,
  petType: false,
  numChip: false,
  petBirthdate: false,
  paymentType: false,
  address: false,
  phone: false,
  iban: false,
  email: false,
};

export const validateBasicData = (values: FormValues, supplementDocs: FormatedSupplementDoc[]) => {
  const newDocType = values && values.newDocType ? values.newDocType : "";
  let { errors } = validateFields( values, basicDataRules(values.check, newDocType, values, supplementDocs) );

  const isOnChangeEvent = false;
    Object.keys(values).forEach(key => {
      const validation = validateStandarisedFieldsSupplements(values[key], key, isOnChangeEvent)
      
      if(validation && validation.isError){
        errors = {
          ...errors,
          [key]: validation.errorCode
        }
      }
    })

  const address = values.address;
  const phone = values.phone;
  const checkAddress = values.check.address;
  const checkPhone = values.check.phone;
  const hasValidation = {
    name: !errors.newName && !errors.newLastname1,
    lastname2: !errors.newLastname2,
    doc: !errors.newDocNumber && !errors.newDocType,
    birthDate: !errors.newBirthDate,
    gender: !errors.newGender,
    nationality: !errors.newNationality,
    documents: !errors.documents,
    petName: !errors.petNewName,
    petType: !errors.newPetType && !errors.newBreed,
    numChip: !errors.newNumChip,
    petBirthdate: !errors.newPetBirthdate,
    newPaymentType: !errors.newPaymentType,
    address: !errors.address,
    iban: !errors.iban,
    phone: !errors.phone,
    email: !errors.email
  };

  return { errors: {...errors,  address: validateAddress(checkAddress, address), phone: validatePhone(checkPhone, phone)}, hasValidation };
};

const validateField = (
  checkField: boolean,
  newField: string,
  customValidation?: (field: string) => string | null
) => {
  if (checkField && !newField) {
    return "required";
  } else if (checkField && newField && customValidation) {
    return customValidation(newField);
  }
  return null;
};

export const basicDataRules = (check: Check, newDocType: string, values: FormValues, supplementDocs: FormatedSupplementDoc[]) => {
  return {
    email: (email: string) => validateField(check.email, email),
    newName: (newName: string) => validateField(check.name, newName),
    newLastname1: (newLastname1: string) =>
      validateField(check.name, newLastname1),
    newLastname2: () =>
      (check.name && values.newLastname2 === '' && values.newNationality && values.newNationality === 'España') ? 'required' : null,
    newDocType: (newDocType: string) => validateField(check.doc, newDocType, () => {
      return validateDocType(values.newDocType, values.newNationality, check.birthDate ? values.newBirthDate : values.birthDate, false, check.doc, true).errorCode;
    }),
    newDocNumber: (newDocNumber: string) => {
      if(check.doc && values.newDocType === 'MENOR'){
        return null
      }else{
        return validateField(check.doc, newDocNumber, (docNumber) => {
          return isValidDocumentID(docNumber, newDocType) ? null : "invalid-format";
        })
      }
    },
    newBirthDate: (newBirthDate: string) =>
      validateField(check.birthDate, newBirthDate),
    newGender: (newGender: string) => validateField(check.gender, newGender),
    newNationality: (newNationality: string) =>
      validateField(check.nationality, newNationality),
    petNewName: (petNewName: string) =>
      validateField(check.petName, petNewName),
    newPetType: (newPetType: string) =>
      validateField(check.petType, newPetType),
    newNumChip: (newNumChip: string) =>
      validateField(check.numChip, newNumChip, (numChip) => {
        return numChip.length !== 15 ? "invalid-num-chip" : null;
      }),
    newPetBirthdate: (newPetBirthdate: string) =>
      validateField(check.petBirthdate, newPetBirthdate),
    newBreed: (newBreed: string) => validateField(check.petType, newBreed),
    documents: (documents: { uploadDocuments: any[] }) => { return validateDocuments(documents, supplementDocs)},
    newPaymentType: (newPaymentType: string) =>
      validateField(check.paymentType, newPaymentType),
    iban: (iban: string) =>
      validateField(check.iban, iban, (iban: string) => { return isValidIban(iban) ? null : "invalid-iban" }),
    address: (address: AddressData) =>
      Object.values(validateAddress(check.address, address)).every((error) => error === null) ? null : "error",
    phone: (phone: PhoneData) =>
      Object.values(validatePhone(check.phone, phone)).every((error) => error === null) ? null : "error",
  };
};

const validateDocuments = (documents: { uploadDocuments: any[] }, supplementDocs: FormatedSupplementDoc[]) => {
  if (!supplementDocs) return null;

  const requiredDocs = supplementDocs.filter((doc) => doc.required);
  if (requiredDocs.length === 0) return null;

  let error = "";
  requiredDocs.forEach((requiredDoc) => {
    const uploadDoc = documents.uploadDocuments.find((doc) => doc.type === requiredDoc.value);
    if (!uploadDoc) {
      error = `${error ? error + " - " : ""}${requiredDoc.label}`;
    }
  });

  return error;
}

const validateAddress = (checkAddress: boolean, address: AddressData) => {
  return {
    province: validateField(checkAddress, address.province.label),
    town: validateField(checkAddress, address.town.label),
    address: validateField(checkAddress, address.address.label),
    number: validateField(checkAddress, address.number),
    postalCode: validateField(checkAddress, address.postalCode),
  };
};

export const validateContact = (checkAContact: boolean, contact: ContactData) => {
  return {
    mobilePhone: validateField(checkAContact, contact.mobilePhone),
    landlinePhone: validateField(checkAContact, contact.landlinePhone),
    email: validateField(checkAContact, contact.email),
  };
};

const validatePhone = (checkPhone: boolean, phone: PhoneData) => {
  return {
    mobilePhone: validateField(checkPhone, phone.mobilePhone),
  };
};

export const isValidStep = (
  hasValidation: HasBasicDataValidationType
): boolean => {
  const { documents, ...rest } = hasValidation;
  return Object.values(rest).every((value) => value);
};

export const getPolicyData = () => {
  const policyDataString = localStorage.getItem("policyData") || "{}";
  return JSON.parse(policyDataString);
};

export const mergeOnlyInsureds = (
  insurances: RiskDetailPersonDataDto[],
  pets: RiskDetailPetDataDto[],
): ResultMergeInsurancesAndTaker[] => {
  let result: ResultMergeInsurancesAndTaker[] = [];

  // Asegurados
  if (Object.keys(insurances).length > 0) {
    insurances.forEach((insurance, index) => {
      // Si el asegurado no tiene el mismo NIF que el tomador, lo añade al array
      result.push({
        value: result.length.toString(),
        label: insurance.nom_asegurado
          ? "ASEGURADO - " + insurance.nom_asegurado
          : "",
        nif: insurance.nif_asegurado,
        birthDate:
          typeof insurance.fec_nacimiento === "string"
            ? insurance.fec_nacimiento
            : insurance.fec_nacimiento.toISOString(),
        gender: insurance.sexo,
        name: insurance && insurance.nom_asegurado,
        breed: "",
        numChip: "",
        petType: "",
        oldProvince: insurance.provincia,
        oldTown: insurance.poblacion,
        oldAddress: insurance.direccion,
        firstName: insurance.nom_propio_asegurado,
        lastname1: insurance.apellido1_asegurado,
        lastname2: insurance.apellido2_asegurado,
        docType: insurance.tipo_documento_asegurado,
        orden: insurance.orden,
      });
    });
  }

  // Mascotas
  if (Object.keys(pets).length > 0) {
    pets.forEach((pet) => {
      result.push({
        value: result.length.toString(),
        label: pet && pet.nom_mascota ? "MASCOTA - " + pet.nom_mascota : "",
        nif: "",
        birthDate:
          typeof pet.fec_nacimiento === "string"
            ? pet.fec_nacimiento
            : pet.fec_nacimiento.toISOString(),
        gender: "",
        name: pet && pet.nom_mascota ? pet.nom_mascota : "",
        breed: pet && pet.raza ? pet.raza : "",
        numChip: pet && pet.chip ? pet.chip : "",
        petType:
          pet && pet.tipo_mascota && pet.tipo_mascota === "CANINA"
            ? "canine"
            : "feline",
        oldProvince: "",
        oldTown: "",
        oldAddress: "",
        firstName: "",
        lastname1: "",
        lastname2: "",
        docType: "",
        orden: pet.orden,
      });
    });
  }
  return result;
};

export const mergeInsurancesAndTaker = (
  insurances: RiskDetailPersonDataDto[],
  taker: Taker,
  pets: RiskDetailPetDataDto[],
  handleMultipleChanges?: (changes: Partial<FormValues>) => void,
): ResultMergeInsurancesAndTaker[] => {
  let result: ResultMergeInsurancesAndTaker[] = [];
  const birthDate = taker && taker.fec_nacimiento_tomador;
  const takerNif = taker && taker.nif_tomador;
  const insuracesNifList = insurances.length > 0 ? insurances.map((insurance) => insurance.nif_asegurado) : [];
  const sameAsTaker = insuracesNifList.includes(takerNif);
  const takerName = (taker && taker.nom_tomador) || "";
  const takerLabel = sameAsTaker ? `TOMADOR Y ASEGURADO - ${takerName}` : `TOMADOR - ${takerName}`;
  
  // Tomador
  result.push({
    value: "0",
    label: takerLabel,
    nif: takerNif,
    birthDate,
    gender: taker && taker.sexo,
    name: takerName,
    breed: "",
    numChip: "",
    petType: "",
    oldProvince: taker.provincia_tomador,
    oldTown: taker.poblacion_tomador,
    oldAddress: taker.direccion_tomador,
    firstName: taker && taker.nom_propio_tomador,
    lastname1: taker && taker.apellido1_tomador,
    lastname2: taker && taker.apellido2_tomador,
    docType: taker && taker.tipo_documento_tomador,
    orden: sameAsTaker ? "1" : "",
  });

  // Asegurados
  if (Object.keys(insurances).length > 0) {
    insurances.forEach((insurance, index) => {
      // Si el asegurado no tiene el mismo NIF que el tomador, lo añade al array
      if (taker && insurance && insurance.nif_asegurado !== taker.nif_tomador) {
        result.push({
          value: result.length.toString(),
          label: insurance.nom_asegurado
            ? "ASEGURADO - " + insurance.nom_asegurado
            : "",
          nif: insurance.nif_asegurado,
          birthDate:
            typeof insurance.fec_nacimiento === "string"
              ? insurance.fec_nacimiento
              : insurance.fec_nacimiento.toISOString(),
          gender: insurance.sexo,
          name: insurance && insurance.nom_asegurado,
          breed: "",
          numChip: "",
          petType: "",
          oldProvince: insurance.provincia,
          oldTown: insurance.poblacion,
          oldAddress: insurance.direccion,
          firstName: insurance.nom_propio_asegurado,
          lastname1: insurance.apellido1_asegurado,
          lastname2: insurance.apellido2_asegurado,
          docType: insurance.tipo_documento_asegurado,
          orden: insurance.orden,
        });
      }
    });
  }

  // Mascotas
  if (Object.keys(pets).length > 0) {
    pets.forEach((pet) => {
      result.push({
        value: result.length.toString(),
        label: pet && pet.nom_mascota ? "MASCOTA - " + pet.nom_mascota : "",
        nif: "",
        birthDate:
          typeof pet.fec_nacimiento === "string"
            ? pet.fec_nacimiento
            : pet.fec_nacimiento.toISOString(),
        gender: "",
        name: pet && pet.nom_mascota ? pet.nom_mascota : "",
        breed: pet && pet.raza ? pet.raza : "",
        numChip: pet && pet.chip ? pet.chip : "",
        petType:
          pet && pet.tipo_mascota && pet.tipo_mascota === "CANINA"
            ? "canine"
            : "feline",
        oldProvince: "",
        oldTown: "",
        oldAddress: "",
        firstName: "",
        lastname1: "",
        lastname2: "",
        docType: "",
        orden: pet.orden,
      });
    });
  }

  return result;
};

export const buttonList = (formTitle: string) => {
  const firstButtonText = formTitle === "CAMBIO DATOS BASICOS" ? "Datos básicos" : formTitle;
  return [
    { buttonText: firstButtonText, stepNumber: 1 },
    { buttonText: "Doc. requeridos", stepNumber: 2 },
  ];
};

export const stepsMenuProps = {
  policyData: {
    policyType: "",
    policyName: "",
    disabled: true,
  },
};

const docTypeDictionary: { [key: string]: string } = {
  DR04: DocumentType[2],
  AUTH: DocumentType[30],
  DR11: DocumentType[31],
};

const getTakerMetadata = ({
  docType,
  isTaker,
  docNumberValue,
  nameValue,
  lastname1Value,
  lastname2Value,
  takerData,
}: {
  docType: string;
  isTaker: boolean;
  docNumberValue: string;
  nameValue: string;
  lastname1Value: string;
  lastname2Value: string;
  takerData: Taker;
}) => {
  if (docType === docTypeDictionary.AUTH) {
    return {
      docNumber: isTaker ? docNumberValue : takerData.nif_tomador,
      name: isTaker ? nameValue : takerData.nom_propio_tomador,
      lastname1: isTaker ? lastname1Value : takerData.apellido1_tomador,
      lastname2: isTaker ? lastname2Value : takerData.apellido2_tomador,
    };
  }

  return {
    docNumber: docNumberValue,
    name: isTaker ? nameValue : "",
    lastname1: isTaker ? lastname1Value : "",
    lastname2: isTaker ? lastname2Value : "",
  };
};

const getNewDocName = ({ docType, docExtension }: { docType: string; docExtension: string }) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const newDocName = `${docType}-${year}${month}${day}-${today.getTime()}.${docExtension}`;
  return newDocName;
};

export const uploadDocument = async (
  doc: any,
  values: FormValues,
  takerData: Taker,
): Promise<GestDocFileInfoResponseDto | null> => {
  const docType: string = doc.type ? docTypeDictionary[doc.type] : "";
  const docExtension = getFileExtension(doc.file.name);
  const newDocName = getNewDocName({ docType: doc.type, docExtension });
  const renamedFile = new File([doc.file], newDocName);

  const isTaker = values.type === PERSONA_TYPE.TOMADOR;
  const isInsured = values.type === PERSONA_TYPE.ASEGURADO;
  const isPet = values.type === PERSONA_TYPE.MASCOTA;
  const sameAsTaker = (!isInsured && !isPet) && values.orden === "1";
  const docNumberValue = values.newDocNumber || values.docNumber;
  const nameValue = values.newName || values.firstName || values.name;
  const lastname1Value = values.newLastname1 || values.lastname1;
  const lastname2Value = values.newLastname2 || values.lastname2;
  const userCode = getUserCode();
  const isPolicyLevel = isPet;

  const taker = getTakerMetadata({
    docType,
    isTaker,
    docNumberValue,
    nameValue,
    lastname1Value,
    lastname2Value,
    takerData,
  });

  const insured = sameAsTaker
    ? { ...taker, orden: "1" }
    : isInsured
      ? {
          docNumber: docNumberValue,
          name: nameValue,
          lastname1: lastname1Value,
          lastname2: lastname2Value,
          orden: values.orden || "1",
        }
      : isPet
        ? {
            name: values.name,
            orden: values.orden || "1",
            docNumber: values.newNumChip || values.numChip,
            lastname1: "",
            lastname2: "",
          }
        : undefined;

  const policyData = localStorage.getItem('policyData');
  const policyDataObj = policyData ? JSON.parse(policyData) : {};
  const metadata = GestDoc.getSupplementClientDocMetadata({
    processEntity: isInsured && docType !== docTypeDictionary.AUTH ? "ASEGURADO" : "TOMADOR",
    docType,
    isLife: values.isLife,
    taker,
    insured,
    isPolicyLevel,
    userCode,
    policyId: values.policy,
    collectiveCode: policyDataObj.numeroColectivo,
    productId: policyDataObj.productId,
    productName: policyDataObj.productName,
  });

  const response = await GestDoc.uploadDocument(CLIENT_NODE_ID, renamedFile, metadata, () => {});

  return response;
};
